/**
 * Creates an onKeyDown handler that triggers the callback on Enter or Space key press.
 * Use alongside onClick on non-interactive elements (div, span, li, img, p) for
 * keyboard accessibility compliance (jsx-a11y/click-events-have-key-events).
 *
 * @param {Function} callback - The same handler passed to onClick
 * @returns {Function} An onKeyDown event handler
 *
 * @example
 * <div role="button" tabIndex={0} onClick={handler} onKeyDown={onEnterOrSpace(handler)}>
 */
export const onEnterOrSpace = (callback) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback(e);
  }
};
